import { useLocalSearchParams } from "expo-router";
import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import PlayerPage from "$src/core/pages/PlayerPage/PlayerPage";
import isValidContentType from "$src/core/utils/dto/is-valid-content-type";

type Params = {
  id: string;
  type: string;
  trailer?: string;
};

const Route: React.FC = () => {
  const { id, type, ...restParams } = useLocalSearchParams<Params>();

  const trailer = restParams.trailer === "true";

  if (!id || !isValidContentType(type)) return null;

  return (
    <PageLayout>
      <PlayerPage
        key={`${type}-${id}-${trailer ? "trailer" : "main"}`}
        id={id.toString()}
        type={type}
        trailer={trailer}
      />
    </PageLayout>
  );
};

export default Route;
